<template>
  <div class="l-siteContainer">
    <HeroSection></HeroSection>
    <FeaturedSection></FeaturedSection>
    <LoyaltySection></LoyaltySection>
    <ExpressSection></ExpressSection>
    <PremiumSection></PremiumSection>
    <HelpSection></HelpSection>
  </div>
</template>

<script>
import HeroSection from '@/components/HeroSection'
import FeaturedSection from '@/components/FeaturedSection'
import LoyaltySection from '@/components/LoyaltySection'
import ExpressSection from '@/components/ExpressSection'
import PremiumSection from '@/components/PremiumSection'
import HelpSection from '@/components/HelpSection'

export default {
  name: 'MainView',
  components: {
    HeroSection,
    FeaturedSection,
    LoyaltySection,
    ExpressSection,
    PremiumSection,
    HelpSection
  }
}
</script>

<style lang="scss" scoped>
</style>
